import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationCountryActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Country/CountryBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationCountry"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationCountry"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationCountryActivity)
